import React from "react";
import "./ReferFrndBanner.scss";
import VideoDrmPlayer from "../../features/video_feature/video_feature_content_component/VideoDrmPlayer";

const ReferFrndBanner = ({ referAndEarnData }) => {
  return (
    <div className="referFrndBannerWrppr">
      {/* <img src={referAndEarnData?.webbanner_image1} alt="refer-and-earn-img" /> */}

      {/* <div className="banner_message">
        <div className="earn-together">Earn Together!</div>
        {referAndEarnData.banner_message}
      </div> */}

      <VideoDrmPlayer id_video={referAndEarnData?.display_video} />
    </div>
  );
};

export default ReferFrndBanner;
